import { api } from './api';

/** Dashboard / future app: billing helpers (API keys and Lemon secrets stay server-side). */

export function getTeacherPlatformPlans() {
  return api.get('/billing/teacher/platform-plans');
}

export function getTenantTeachersForBilling() {
  return api.get('/billing/teacher/tenant-teachers');
}

export function getPaygUsagePreview() {
  return api.get('/billing/teacher/payg-usage-preview');
}

/** Signed Lemon URLs: customer portal + update payment (platform subscription). 404 if no sub synced yet. */
export function getTeacherPlatformCustomerLinks() {
  return api.get('/billing/teacher/platform-subscription/customer-links');
}

export function listSaasPlansAdmin(params?: { activeOnly?: boolean }) {
  return api.get('/billing/saas-plans', { params });
}

export type CancelSubscriptionBody = { reason?: string };

export function cancelStudentLessonSubscription(subscriptionId: string, body?: CancelSubscriptionBody) {
  return api.post(`/billing/student/lesson-subscriptions/${subscriptionId}/cancel`, body ?? {});
}

export function cancelTeacherStudentLessonSubscription(subscriptionId: string, body?: CancelSubscriptionBody) {
  return api.post(`/billing/teacher/student-lesson-subscriptions/${subscriptionId}/cancel`, body ?? {});
}

export function cancelTenantPlatformSubscription(body?: CancelSubscriptionBody) {
  return api.post(`/billing/teacher/platform-subscription/cancel`, body ?? {});
}

export function getStudentLessonCredits() {
  return api.get('/billing/student/lesson-credits');
}

/** Teachers with active Lemon lesson pricing (student checkout picker). */
export function getStudentCheckoutTeachers() {
  return api.get('/billing/student/checkout-teachers');
}

export function getTeacherLessonPricing(params?: { teacherAuthUserId?: string }) {
  return api.get('/billing/teacher/lesson-pricing', { params });
}

export function putTeacherLessonPricing(
  body: { currencyCode: string; unitAmountCents: number; lemonVariantId?: string | null; isActive?: boolean },
  params?: { teacherAuthUserId?: string }
) {
  return api.put('/billing/teacher/lesson-pricing', body, { params });
}

export function postTeacherCheckout(body: { planSlug?: string; planId?: string; redirectUrl?: string }) {
  return api.post('/billing/teacher/checkout', body);
}

export function postStudentLessonCheckout(body: {
  teacherAuthUserId: string;
  quantity: number;
  redirectUrl?: string;
}) {
  return api.post('/billing/student/checkout', body);
}
